import React, { useState } from 'react';
import DragDropHelpers, { getName } from './DragDropHelpers'
import Vote from '../../../components/Vote'
import { getVotes } from '../../../helpers/applications';

const AvailableFields = (props) => {

  const dragDropHelpers = new DragDropHelpers(props.types)
  const [showAll, setShowAll] = useState(false)

  const [hasPopularFields] = useState(props.types.find((type) => type.popularFields))

  const getFieldsList = (type) => {
    //TODONOW: Remove this and try creating a workflow
    if (!type) {
      return []
    }
    let filteredFields = type.fields.filter(
      field =>
        (!props.dataTypes || props.dataTypes.find(a => a === field.dataType)) && (
          showAll || !type.popularFields || type.popularFields.includes(field.id)
          || type.popularFields.find(a => a.startsWith(field.id + "."))
        )
    )
    let sortedFields = filteredFields.sort((a, b) => (a.name > b.name) ? 1 : -1)
    return sortedFields;
  }

  const getDescription = (field) => {
    if (field.description) {
      return field.description
    }
    if (field.label) {
      return field.label
    }
    if (field.value) {
      return "An example value: " + field.value
    }
    return field.name
  }

  const toggleShowAll = () => {
    setShowAll(!showAll)
  }


  const renderType = (type, ident) => {
    if (type.forbidden) {
      //TODONOW: Add a vote with reason not supported
      return <div key={type.application}>
        {type.description} <br />
        <Vote votes={getVotes(type.application)} type="application" docId={type.application} />
      </div>
    }
    //TODO: Find how to not have 2 getName(field)
    let fieldsList = getFieldsList(type).map((field) => <div key={field.id}>
      {(showAll || !type.popularFields || type.popularFields && type.popularFields.includes(field.id)) && getName(field) !== "" ? <>
        <input type="button"
          data-typeid={field.typeId}
          draggable="true"
          onDragStart={dragDropHelpers.dragStart}
          className="input-field"
          style={{ marginLeft: ident + "px", maxWidth: props.isLegacy? "" : "unset" }}
          id={field.id}
          key={field.id}
          data-toggle="tooltip"
          data-placement="top"
          title={getDescription(field)}
          value={showAll || !type.popularFields ? field.name : getName(field)}
          onClick={() => props.onFieldClick?.(field)}
        ></input> <br />
      </> : ""}
      {field.dataType === "$ref" && field.subtype ? renderType(field.subtype, ident + ((showAll || !type.popularFields) ? 10 : 0)) : ""}
    </div>
    );
    return fieldsList.length > 0 ?
      <div key={type.id + type.name}>
        {type.name}
        <br />
        {fieldsList}
      </div>
      : ""
  }

  //TODO: Localize
  return <div className="available-fields">
    {/* TODONOW: WHY this is not working ?!? <div className="custom-control custom-switch" key={"t_" + showAll} >
    <input type="checkbox" className="custom-control-input" id="viewall" key={"X_" + showAll}
      checked={showAll}
      onClick={toggleShowAll} />
    <label className="custom-control-label" key={"l" + showAll} htmlFor="viewall">view all{"" + showAll}aaa</label>
  </div> */}
    {hasPopularFields ?
      <div>
        <input type="checkbox" id="viewall"
          checked={showAll}
          onChange={toggleShowAll} /> show all fields
      </div>
      : ""}
    {props.types.map((type) => renderType(type, 0))}

  </div>
}

export default AvailableFields

